import {
  // -- GET (list)
  GET_PROJECT_PARAMETERS_SUCCESS,
  GET_PROJECT_PARAMETERS_FAILURE,
  // -- CREATE
  CREATE_PROJECT_PARAMETER_SUCCESS,
  CREATE_PROJECT_PARAMETER_FAILURE,
  // -- UPDATE
  UPDATE_PROJECT_PARAMETER_SUCCESS,
  UPDATE_PROJECT_PARAMETER_FAILURE,
  // -- DELETE
  DELETE_PROJECT_PARAMETER_SUCCESS,
  DELETE_PROJECT_PARAMETER_FAILURE,
  // -- SEARCH
  SEARCH_PROJECT_PARAMETERS
} from '../../../actions'
import { Logger, LoggerTypes } from '../../../utils'

let cacheItems = null

export const projectParameters = (state = {}, action) => {
  switch (action.type) {
    // -- GET PROJECT PARAMETERS (list)
    case GET_PROJECT_PARAMETERS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectParameters.GET_PROJECT_PARAMETERS_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_PROJECT_PARAMETERS_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectParameters.GET_PROJECT_PARAMETERS_SUCCESS()', {
        state,
        action
      })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE PROJECT PARAMETER
    case CREATE_PROJECT_PARAMETER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectParameters.CREATE_PROJECT_PARAMETER_FAILURE()', {
        state,
        action
      })
      return { ...state, error: action.data }
    }
    case CREATE_PROJECT_PARAMETER_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectParameters.CREATE_PROJECT_PARAMETER_SUCCESS()', {
        state,
        action,
        newItems
      })
      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE PROJECT PARAMETER
    case UPDATE_PROJECT_PARAMETER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectParameters.UPDATE_PROJECT_PARAMETER_FAILURE()', {
        state,
        action
      })
      return { ...state, error: action.data }
    }
    case UPDATE_PROJECT_PARAMETER_SUCCESS: {
      const items = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectParameters.UPDATE_PROJECT_PARAMETER_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- DELETE PROJECT PARAMETER
    case DELETE_PROJECT_PARAMETER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] projectParameters.DELETE_PROJECT_PARAMETER_FAILURE()', {
        state,
        action
      })
      return { ...state, error: action.data }
    }
    case DELETE_PROJECT_PARAMETER_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] projectParameters.DELETE_PROJECT_PARAMETER_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- SEARCH PROJECT
    case SEARCH_PROJECT_PARAMETERS: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }

      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      return {
        ...state,
        items: searchItems
      }
    }

    default:
      return state
  }
}
